{
  "allowed": [
    "paoe_entry_once",
    "77A044B7-7041-CA96-3C63-BB718B15A364",
    "dies",
    "slipping_away",
    "creature_fell",
    "82BBB3B6-4646-48E8-A5A2-8DC0947A91D0",
    "creature_killed",
    "creature_body_vanishes",
    "massive_damage_instant_death",
    "drop_inventory",
    "concentration_broken",
    "start_turn",
    "start_legendary_turn",
    "merchant_inventory_teleported",
    "effect_ends_on_target_start_of_turn",
    "effect_ends_on_target_end_of_turn",
    "status_effect_expired",
    "no_roll",
    "reaction_ability_applied",
    "passive_ability_applied",
    "free_ability_applied",
    "attack_ability_applied",
    "status_stack_decreased",
    "lost_a_mirror_image",
    "janus_unported_skip",
    "target_status_effect_applied",
    "self_status_effect_applied",
    "status_effect_applied_to_caster_after_cast",
    "adjust_charges",
    "resource_reduction_prevented",
    "status_effect_applied",
    "status_effect_applied_to_target_after_contesting_roll_failed",
    "status_stack_increased",
    "invalid_target_for_status_effect",
    "4FB7452A-F130-40C3-83E6-5E92C329D7B2",
    "9909BE44-99AE-8780-BB12-BD99BA6E672E",
    "4634635E-4E82-DFB3-8411-27A6BFB8CF0F",
    "F5BC82EE-DBDF-4594-F850-0C49E4292AC7",
    "5E2689A2-0F7D-1E27-F4D5-CA09CA5C2591",
    "ED5B44EA-7438-9582-A388-04EFF342E460",
    "AD80D31D-898B-66CE-0894-1335D11B1529",
    "unlucky_roll",
    "concentration_maintained",
    "status_effect_removed_from_target_after_cast",
    "status_effect_removed_after_contesting_roll_passed",
    "gained_ascension_skill_point",
    "failed_roll_for_ascension_skill_point",
    "ascension_skill_tier_up",
    "target_creature_revealed",
    "target_immune_to_status_effect",
    "self_status_effect_deleted",
    "reaction_gained",
    "ap_change_during_turn",
    "spell_concentration",
    "passive_ability_applied_to_caster_after_cast",
    "status_effect_applied_to_target_after_cast",
    "status_effect_applied_to_caster_on_hit",
    "status_effect_applied_to_target_on_hit",
    "post_effect_condition_failed",
    "damage_heals_caster"
  ],
  "private": [
    "resource_reduction_prevented",
    "dies",
    "slipping_away",
    "creature_fell",
    "82BBB3B6-4646-48E8-A5A2-8DC0947A91D0",
    "creature_killed",
    "creature_body_vanishes",
    "massive_damage_instant_death",
    "drop_inventory",
    "concentration_broken",
    "start_turn",
    "start_legendary_turn",
    "status_effect_expired",
    "status_effect_applied",
    "status_effect_applied_to_target_after_contesting_roll_failed",
    "status_stack_increased",
    "invalid_target_for_status_effect",
    "janus_unported_skip",
    "merchant_inventory_teleported",
    "effect_ends_on_target_start_of_turn",
    "effect_ends_on_target_end_of_turn",
    "target_immune_to_status_effect",
    "self_status_effect_deleted",
    "reaction_gained",
    "ap_change_during_turn",
    "spell_concentration",
    "passive_ability_applied_to_caster_after_cast",
    "status_effect_applied_to_target_after_cast",
    "status_effect_applied_to_caster_on_hit",
    "status_effect_applied_to_target_on_hit",
    "post_effect_condition_failed"
  ]
}
